import { Api, ApiTypes, BodyOf, ResultOf } from '@app/api';

type AccountStatementDto = ApiTypes.AccountStatementListItemResponseDto;
type VenueStatementDto = ApiTypes.VenueStatementListItemResponseDto;

export type StatementTranslationFromBackend = ApiTypes.StatementTranslationItemResponseDto;
export type StatementFromBackend = Omit<AccountStatementDto, 'isEnforced'> &
  Partial<Pick<AccountStatementDto, 'isEnforced'> & Pick<VenueStatementDto, 'isAccountEnforced'>>;
export type StatementsFromBackend = Record<string, StatementFromBackend[]>;
export type StatementTranslation = Record<string, string>;
export interface StatementGroup {
  groupName: string;
  groupUuid: string;
  statements: Statement[];
}
export type Statement = Pick<StatementFromBackend, 'uuid' | 'isOnlyStatementWithFullTranslations'> &
  Partial<
    Omit<StatementFromBackend, 'uuid' | 'isOnlyStatementWithFullTranslations' | 'translations'>
  > & {
    translations: StatementTranslation;
  };
type CreateStatementBody = Api.surveys.accounts.statements.PostBody;
export type NewStatementFormForBackend = Pick<CreateStatementBody, 'translations'> &
  Partial<Pick<CreateStatementBody, 'categoryUuid'>>;
export type ModifiedStatementFormForBackend = NewStatementFormForBackend &
  Pick<BodyOf<typeof Api.surveys.statements, 'put'>, 'accountUuid'>;
export enum StatementType {
  STANDARD = 'standard',
  CUSTOM = 'custom',
}
/**
 * The backend (PHP) serializes the missing-languages array as an object with
 * numeric keys when indices are non-sequential, e.g. {"0": "sv-SE", "2": "en-GB"}.
 */
export type MissingTranslationsForLanguages = string[] | Record<string, string> | null;

export type StatementSavedStatus = Omit<
  Api.surveys.accounts.statements.PostResult,
  'missingTranslationsForLanguages'
> & {
  missingTranslationsForLanguages: MissingTranslationsForLanguages;
};
export type StatementModifiedStatus = Omit<
  ResultOf<typeof Api.surveys.statements, 'put'>,
  'missingTranslationsForLanguages'
> & {
  missingTranslationsForLanguages: MissingTranslationsForLanguages;
  questionCopy: ModifiedStatementFormForBackend;
};
export type StatementActivationChangeStatus = ApiTypes.ManageStatementAssignmentResultResponseDto;
export enum StatementPopupType {
  ACTIVATION = 'activation',
  ENFORCEMENT = 'enforcement',
}
